<template>
  <div class="row mb-3" v-if="steps.length">
    <div
      class="col-3"
      v-for="(step, index) in steps" :key="`step-${index}`"
    >
      <div class="step-wrapper">
        <span class="step-number">{{step.stepNumber}}</span>
        <span class="step-delete">
          <vs-icon
            icon="highlight_off"
            size="small"
            bg="white"
            round
            @click="$emit('remove-step', step)"
          />
        </span>
        <div class="text-center step-name">
          <div v-if="step.stepType === stepTypes.PROVIDER">
            <b>{{step.data.extra.empresa.razon}}</b>
            <div>
              {{step.data.extra.empresa.iut}}
            </div>
          </div>
          <div v-if="step.stepType === stepTypes.EXTERNAL">
            <div>
              {{step.data.responsable.rut}}
            </div>
          </div>
          <div v-if="step.stepType === stepTypes.PERSON">
            {{step.responsibleIut}}
          </div>
          {{ step.responsibleName }}
          <div
            v-if="step.stepType === stepTypes.PERSON"
            class="text-truncate"
            v-b-tooltip="step.responsibleEmail"
          >
            {{step.responsibleEmail}}
          </div>
          <span
            v-if="step.stepType === stepTypes.GROUP"
            v-b-tooltip="'Integrantes del grupo'"
          >
            ({{(step.groupUsers.length) }})
          </span>
        </div>
        <div class="step-type">
          <span v-if="step.distributed" v-b-tooltip="'Distribuido: se asigna a 1 persona del grupo secuencialmente'" class="mr-1">
            <vs-icon icon="share" size="12px" color="warning" />
          </span>
          <span v-if="step.stepType === stepTypes.USER">
            usuario
          </span>
          <span v-if="step.stepType === stepTypes.GROUP">
            grupo
          </span>
          <span v-if="step.stepType === stepTypes.PROVIDER">
            proveedor
          </span>
          <span v-if="step.stepType === stepTypes.OFFICE">
            oficina
          </span>
          <span v-if="step.stepType === stepTypes.PERSON">
            persona
          </span>
          <span v-if="step.stepType === stepTypes.EXTERNAL">
            externo
          </span>
          <span v-if="step.stepType === stepTypes.COMPLETION">
            completitud
          </span>
        </div>
        <div class="step-rol">
          <span v-if="step.rolType === rolTypes.CONFIGURATOR">
            configurador
          </span>
          <span v-if="step.rolType === rolTypes.APPROVER">
            aprobador
          </span>
          <span v-if="step.rolType === rolTypes.SIGNER && step.stepType !== stepTypes.OFFICE">
            firmante
          </span>
          <span v-if="step.rolType === rolTypes.REVIEWER">
            revisor
          </span>
          <span v-if="step.stepType === stepTypes.OFFICE && step.rolType === rolTypes.SIGNER">
            num/tramitar
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StepTypes from '@/febos/chile/dnt/mixins/StepTypes';
import RolTypes from '@/febos/chile/dnt/mixins/RolTypes';

export default {
  data() {
    return {
      rolTypes: RolTypes,
      stepTypes: StepTypes
    };
  },
  props: {
    steps: {
      type: Array,
      required: true
    }
  }
};
</script>
<style>

.step-wrapper {
  border: 1px solid #662483;
  padding: 10px;
  border-radius: 5px;
  position: relative;
  margin-top: 20px;
}

.step-number {
  position: absolute;
  top: -10px;
  left: -4px;
  padding: 2px 8px;
  background: #16c86b;
  border-radius: 50%;
  color: white;
  font-size: 12px;
}

.step-delete {
  position: absolute;
  top: -10px;
  right: -4px;
  font-size: 10px;
  color: #b11e0b;
  cursor: pointer;
}

.step-rol {
  position: absolute;
  bottom: -10px;
  right: -1px;
  padding: 2px 8px;
  background: #671e85;
  border-radius: 5px;
  color: white;
  font-size: 12px;
}

.step-type {
  position: absolute;
  bottom: -10px;
  left: -1px;
  padding: 2px 8px;
  background: #155f87;
  border-radius: 5px;
  color: white;
  font-size: 12px;
}

.step-name {
  padding: 8px 0;
}
</style>
